import { Routes, Route, Navigate } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AuthPage } from './pages/auth/AuthPage'
import Home from './pages/Home'

// Lazy load heavy components
const TradingStudio = lazy(() => import('./pages/studio/TradingStudio').then(module => ({
  default: module.TradingStudio
})))

// Loading component for suspense
const LoadingFallback = () => (
  <Box 
    sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: '#1a1a1a'
    }}
  >
    <CircularProgress />
  </Box>
)

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route 
          path="/studio" 
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingFallback />}>
                <TradingStudio />
              </Suspense>
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
